"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Weth = void 0;
const adapter_1 = __importDefault(require("./adapter"));
const ERC20_ABI = require("../../abi/erc20.json");
const addresses = {
    1: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
    3: '0xc778417e063141139fce010982780140aa0cd5ab',
    4: '0xc778417e063141139fce010982780140aa0cd5ab',
    42: '0xd0a1e359811322d97991e03f863a0c30c2cf029c',
    56: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    137: '0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270',
};
class Weth extends adapter_1.default {
    static getAddress(network = 1) {
        return addresses[network];
    }
    static getDexData(optimalRate, name) {
        return {
            name,
            srcAmount: optimalRate.srcAmount,
            destAmount: optimalRate.destAmount,
        };
    }
    getWeth() {
        const address = Weth.getAddress(this.network);
        const contract = new this.web3Provider.eth.Contract(ERC20_ABI, address);
        return { address, contract };
    }
    buildSwap(srcToken, destToken, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const { address, contract } = this.getWeth();
            const swapData = this.isETHAddress(srcToken)
                ? contract.methods.deposit().encodeABI()
                : contract.methods.withdraw(data.srcAmount).encodeABI();
            return this.swap(srcToken, destToken, data, swapData, address);
        });
    }
}
exports.Weth = Weth;
//# sourceMappingURL=weth.js.map